var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#03E9F4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,127.1h-58.2l9.8-58.7c2.9-17.4-8.9-33.9-26.3-36.8c-17.5-2.9-33.9,8.9-36.8,26.3l-11.5,69.3h-95.1 l9.8-58.7c2.9-17.4-8.9-33.9-26.3-36.8c-17.5-2.9-33.9,8.9-36.8,26.3l-11.6,69.3H64c-17.7,0-32,14.3-32,32c0,18.6,14.3,32,32,32 h58.2l-21.3,128H32c-17.7,0-32,14.3-32,32s14.3,31.1,32,31.1h58.2l-9.8,58.7c-2.9,17.4,8.9,33.9,26.3,36.8c1.8,2.1,3.6,2.2,5.3,2.2 c15.4,0,28.9-11.1,31.5-26.7l11.5-69.3h95.1l-9.8,58.7c-2.9,17.4,8.9,33.9,26.3,36.8c1.8,0.3,3.6,0.4,5.3,0.4 c15.4,0,28.9-11.1,31.5-26.7l11.5-69.3H384c17.7,0,32-14.3,32-31.1c0-17.7-14.3-32-32-32h-58.2l21.3-128H416c17.7,0,32-14.3,32-31.1 C448,142.3,433.7,127.1,416,127.1z M260.9,319.1h-95.1l21.3-128h95.1L260.9,319.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.fac69b93d60dfd8a1f6355adb7d0c74f.svg";
export { ForwardRef as ReactComponent };